import React, { useEffect, useMemo } from 'react'
import { getFullNameInitials } from '../../helpers';
import { format } from 'date-fns';
import styles from "./ConsultationParentComponent.module.scss"
import { useAppDispatch, useAppSelector } from '../../store/store';
import { fetchServicesTranslations, selectServicesTranslations } from '../../store/slices/salesOrders';
import { buildTranslatedServicesMap, getTranslatedServicesName } from '../../utils/miscUtils';


export default function UserInfo({ selectedSalesOrder }: any) {

    const servicesTranslations = useAppSelector(selectServicesTranslations);
    const lang = localStorage.getItem('lang') || 'en';
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(fetchServicesTranslations());
      }, [dispatch]);

  const translatedServicesMap = useMemo(
  () => buildTranslatedServicesMap(servicesTranslations, lang),
  [servicesTranslations, lang]
);



    return (
        <div className={styles.userInfo}>
            <div className={styles.dFlex}>
                <div className={styles.avatar}>{getFullNameInitials(`${selectedSalesOrder?.customer_person?.person_firstname} ${selectedSalesOrder?.customer_person?.person_lastname}`)}</div>
                <p className={styles.title}>{`${selectedSalesOrder?.customer_person?.person_firstname} ${selectedSalesOrder?.customer_person?.person_lastname}`}</p>
            </div>
            <div className={styles.mt2}>
                <p className={styles.subTitle}>
                    
                     {getTranslatedServicesName(
                        selectedSalesOrder?.service?.service_id,
                         translatedServicesMap
                        )
                         }
                </p>
                <p className={styles.smText}>
                    {format(
                        new Date(
                            selectedSalesOrder?.sales_order_appointment?.start ??
                            selectedSalesOrder?.sales_order?.datetime_create ??
                            Date.now()
                        ),
                        'dd.MM.yyyy | HH:mm'
                    )}
                </p>
            </div>
        </div>
    )
}
